import axios from "axios"

function getUserBackoffice({ id }) {
    return axios.get(`/api/users/${id}`)
}

function postNewTrialLiveSessionChoiceBackoffice({ id }, values) {
    return axios.post(`/api/users/${id}/trial-slots`, values)
}

function getTutors(params) {
    return axios.get("/api/tutors", { params })
}

function assignTutorAndSlot({ user_id }, data) {
    return axios.post(`/api/users/${user_id}/assign-tutor-and-slot`, data)
}

function putStudentAccount({ user_id }, values) {
    return axios.put(`api/backoffice/users/${user_id}/student-account`, values)
}

function putTutorAccount({ user_id }, values) {
    return axios.put(`api/backoffice/users/${user_id}/tutor-account`, values)
}

function newStudent({}, values) {
    return axios.post(`/api/v1/backoffice/users`, values)
}

function updateTutorSlots({ user_id }, values) {
    return axios.put(`/api/backoffice/${user_id}/interview-slots`, values)
}

function getLiveReports({}, {}, params) {
    return axios.get(`api/v1/backoffice/live-reports`, { params })
}

function getDashboards({}, {}, params) {
    return axios.get(`api/v2/dashboards`, { params })
}

function getUserInvoices({ userId }) {
    return axios.get(`/api/backoffice/users/${userId}/invoices`)
}

export const backOfficeService = {
    postNewTrialLiveSessionChoiceBackoffice,
    getUserBackoffice,
    assignTutorAndSlot,
    getTutors,
    putStudentAccount,
    putTutorAccount,
    updateTutorSlots,
    newStudent,
    getLiveReports,
    // Dashboard v2 API methods
    getDashboards,
    // Invoice management
    getUserInvoices,
    // Attribution Tickets
}
